module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Alaskan sailors can get up close and personal with massive glaciers.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "chapter1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/ch01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During the Alaskan gold rush at the turn of the last century, most fortune-seekers arrived via sailboat and quickly took to the interior. Some who arrive in the forty-ninth state today stay closer to the coast—and as Deborah Altermatt relates, that may be a more rewarding decision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We came to Seward in 1994 and it wasn’t long before we sailed in Resurrection Bay,” Deborah recalled. “Soon after, we purchased a sailboat. It’s really the best way to explore the region. To reach many places, it’s the only way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would be an understatement to say that Alaska has a great deal of shoreline to explore: 47,300 miles unfold, from the northernmost reaches on the Beaufort Sea near Barrow to the southeast region that snakes along the northwestern edge of British Columbia. This staggering amount of terrain amounts to more shoreline than that of the lower forty-eight states combined! The relatively finite stretch from Seward to Sitka—a mere 500 miles from north to south, with just 15,000 miles of shoreline—sees the great majority of Alaska’s recreational maritime traffic, much of this in the form of cruise ships plying the famed “Inside Passage.” Cruise-ship passengers get to take in some marvelous sights—Glacier Bay, for example—and have opportunities to purchase T-shirts and other assorted trinkets in each port of call. However, they miss the chance to tuck into more isolated fjords where one can get up close and personal with glaciers, sea lions, and other facets of the Alaska landscape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many voyagers use Seward and Resurrection Bay as a point of departure for Inside Passage adventures. Deborah sees little reason to venture afield from her home waters. “The sailing conditions in Resurrection Bay are pretty darn ideal,” she explained. “The wind blows 15 to 20 knots most of the time. It comes from the north in the a.m., when "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("you’re most likely to be sailing south; in the afternoon, it comes off the Gulf of Alaska, from the south, when you’re likely to be heading back to Seward. The water is generally 100 fathoms deep, so there are few hazards to deal with, and there are countless sheltered anchoring spots. If you sail south from Seward and hang a left, you’re in Prince William Sound. If you hang a right, you’re in Kenai Fjords National Park.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s the fjords and glaciers—the dramatic counterpoint of the sea and cliffs of basalt and ice—that make the shoreline of the Alaska panhandle so enchanting to behold. That, and the many animals that call the waters and the thin strips of forest among the ice fields home. Viewing an 8,000-foot peak when you’re standing at an altitude of 5,000 feet is impressive; seeing that same elevation gain from sea level can take your breath away. “Most cruising visitors take in the glaciers and other fjord attractions farther south,” Deborah added. “You can see all the same things in Kenai Fjords National Park, but without the crowds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kenai Fjords National Park encompasses over 600,000 acres on the southeast coast of the Kenai Peninsula, and includes two significant ice fields—Harding and Grewingk-Yalik—which are occasionally punctuated by mountains from the Kenai Range. The ice fields have had a significant effect in forging the jutted, rutted landscape. The ice fields slowly melt, giving birth to glaciers, which can be thought of as rivers of ice. As the glaciers recede, they slowly carve away canyons of rock, which are filled in by seawater to create fjords. Eight tidewater glaciers stretch down to the ocean surface in the borders of the park. When such a glacier “calves” (sheds portions of ice) to create small icebergs, the roar of shearing ice echoes through the fjords and can be heard miles away; waves large enough to upset a small craft are sometimes generated by the impact of ice and water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The animal life of coastal Alaska is as much an attraction for seafarers as the awe-inspiring scenery. In and around the fjords of Resurrection Bay, you may encounter Steller sea lions, Dall porpoises, gray, humpback, minke and killer whales (orcas), and countless sea birds, including common murres and horned and tufted puffins; you’ll definitely come upon sea otters, which are extremely abundant (and, in Deborah’s opinion, incredibly cute). The region’s more landlocked inhabitants—moose, mountain goats, and the occasional black or brown bear—can sometimes be viewed from the water. Bald eagles are a dime a dozen in this part of the world; after you’ve been in Alaska a few days, you’ll barely look up as one of these majestic birds flies overhead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("When asked to name a favorite itinerary, Deborah suggested a quick cruise to a spot called Thumb Cove. “It’s just seven miles or so from Seward. During the off-season when we’re not running tours or charters, we can take off after work and be there by seven p.m. Even in late April, it’s light until eleven, so there’s plenty of time to set up and/or explore. You anchor in an amphitheater of tall mountains that have glaciers. Often we’ll see foraging bears and mountain goats from the boat. Pods of orcas will sometimes come into the cove and ‘sing’ to us. Once we’ve anchored, we’ll dinghy to the beach. Some people will camp there; others may get a cabin [provided for a nominal fee by the Forest Service] nearby. We’ll make a great driftwood bonfire. Next morning we’ll have mimosas on the deck of the boat, while eagles soar above us. We’ll pull anchor by lunchtime, and if all goes right, we’ll have the southerly breeze to push us home.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentm"
  }, [_c('strong', [_vm._v("Deborah Altermatt")]), _vm._v(" came to Alaska in 1977 with her husband to teach school in the Alaskan bush. She learned to sail on a small lake in the interior after being inspired by regattas she witnessed during a vacation on the French Riviera. She came to Seward in 1994 and took a sailing class from Sailing, Inc. ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.sailinginc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sailinginc.com")]), _vm._v("); a few months later, she bought the business, which she continues to operate today, offering day sails, sailing instruction, and yacht brokering. Deborah offers would-be sailors some sage counsel: “When you buy a sailboat, watch out. You never know how it will change your life!”")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/ifyougo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Getting There:")]), _vm._v(" Most visitors reach Seward by flying into Anchorage and either renting a car, or taking a motorcoach or a train south. Motorcoach and rail options are described in detail at Alaska Tour & Travel (800-208-0200; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.alaskatravel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.alaskatravel.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Best Time to Visit:")]), _vm._v(" May through August will provide the most temperate weather.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Charter Operators:")]), _vm._v(" Sailing, Inc. (907-224-3160; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.sailinginc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sailinginc.com")]), _vm._v(") provides bareboat charters on a limited basis. Skippered charter providers include Alaskan Sailing Charters (866-486-1732; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.kodiaksailingcharters.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kodiaksailingcharters.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Moorings:")]), _vm._v(" Moorings are available in the Seward Small Boat Harbor (907-224-3138; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.cityofseward.net/harbor",
      "target": "_blank"
    }
  }, [_vm._v("www.cityofseward.net/harbor")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/arrow.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("On-Shore Accommodations:")]), _vm._v(" The Seward Visitors & Convention Bureau (907-224-8051; "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.sewardak.org",
      "target": "_blank"
    }
  }, [_vm._v("www.sewardak.org")]), _vm._v(") outlines lodgings options.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed11cd74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 87
// module chunks = 0